import { useState } from "react";

/* Small "!" affordance next to a field label. Shows its note on hover, on keyboard
   focus, and on click/tap (click pins it open so touch users can read it).
   The tooltip is positioned against the nearest positioned ancestor and is w-full,
   so it can never spill outside the field column and get clipped by a scrolling
   container. Callers must put `relative` on the label row.
   Shared by EstimateModal.jsx (estimate form) and EstimateLinkPage.jsx (one-time link). */
export default function HintDot({ hint, testid }) {
  const [hover, setHover] = useState(false);
  const [pinned, setPinned] = useState(false);
  if (!hint) return null;
  const show = hover || pinned;
  return (
    <>
      <button
        type="button"
        aria-label={show ? "Hide note" : "Show note"}
        aria-expanded={show}
        title=""
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        onFocus={() => setHover(true)}
        onBlur={() => { setHover(false); setPinned(false); }}
        onClick={() => setPinned((p) => !p)}
        onKeyDown={(e) => { if (e.key === "Escape") { setPinned(false); setHover(false); } }}
        className="grid place-items-center w-4 h-4 shrink-0 rounded-full bg-paw-primary text-white text-[10px] font-bold leading-none transition-colors hover:bg-paw-navy focus:outline-none focus:ring-2 focus:ring-paw-primary/40"
        data-testid={testid ? `${testid}-hint` : undefined}
      >
        !
      </button>
      {show && (
        <span
          role="tooltip"
          className="absolute left-0 top-full mt-1.5 z-30 w-full rounded-lg bg-paw-navy px-3 py-2 font-manrope text-[11px] font-normal leading-snug text-white shadow-xl pointer-events-none"
          data-testid={testid ? `${testid}-hint-text` : undefined}
        >
          {hint}
        </span>
      )}
    </>
  );
}
